// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__25ywB","formWrapper":"styles_formWrapper__2lLDN","input":"styles_input__3xsUT","submitBtn":"styles_submitBtn__7ncFx","title":"styles_title__3hpjP"};